"use strict";

var _interopRequireDefault = require("/var/www/html/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
require("core-js/modules/es7.symbol.async-iterator");
require("core-js/modules/es6.symbol");
require("core-js/modules/es6.array.from");
require("core-js/modules/es6.regexp.to-string");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.set");
require("core-js/modules/es6.number.is-nan");
var _toConsumableArray2 = _interopRequireDefault(require("/var/www/html/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
var _defineProperty2 = _interopRequireDefault(require("/var/www/html/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.number.constructor");
var _pattern = require("@/api/pattern");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  props: {
    // 模型列表
    patternList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 配置类型列表
    configTypeList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 预设配置列表
    presetConfigList: {
      type: Object,
      default: function _default() {}
    },
    // 修改状态列表
    changeStateList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 禁止修改的标识
    forbidModifyFlag: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      date: '',
      // 预设日期
      dateValidationMessage: '',
      // 日期验证消息
      rules: {
        checkedType: {
          required: true,
          message: '请选择配置类型',
          trigger: 'blur'
        },
        changeState: {
          required: true,
          message: '请选择操作类型',
          trigger: 'blur'
        }
      },
      ruleForm: {
        checkedType: '',
        // 改为单选
        changeState: 1 // 0 可修改，1 禁止修改，默认禁止修改
      },
      // 可复用的初始化配置值列表
      initRatioList: [{
        value: '',
        label: '',
        weight: 0,
        orders: 0,
        // 预计订单数
        limit: 0,
        // 上限
        showLimit: false
      }],
      todayOrders: 0,
      // 今日可导订单（初始值使用昨日可导订单值）
      activeTab: '',
      // 当前激活的标签页
      allConfigItems: [] // 统一的预设配置列表
    };
  },
  computed: {
    // 是否可以加预设日期
    canAddPresetDate: function canAddPresetDate() {
      var _this = this;
      if (!this.date) return false;

      // 检查日期是否为明天以后（不包括今天）
      var tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      tomorrow.setHours(0, 0, 0, 0);
      var selectedDate = new Date(this.date);
      selectedDate.setHours(0, 0, 0, 0);
      if (selectedDate < tomorrow) {
        this.dateValidationMessage = '只能选择明天以后的日期';
        return false;
      }

      // 检查是否已存在相同日期的预设
      var existingDate = this.allConfigItems.find(function (item) {
        return item.date === _this.date;
      });
      if (existingDate) {
        this.dateValidationMessage = '该日期已存在预设配置';
        return false;
      }

      // 检查配置类型是否选择
      if (!this.ruleForm.checkedType) {
        this.dateValidationMessage = '请选择配置类型';
        return false;
      }
      this.dateValidationMessage = '';
      return true;
    },
    // 日期选择器配置
    datePickerOptions: function datePickerOptions() {
      return {
        disabledDate: function disabledDate(time) {
          // 禁用今天及以前的日期，只允许选择明天及以后的日期
          var tomorrow = new Date();
          tomorrow.setDate(tomorrow.getDate() + 1);
          tomorrow.setHours(0, 0, 0, 0);
          return time.getTime() < tomorrow.getTime();
        }
      };
    }
  },
  watch: {
    // 监听配置类型变化，加载对应的预设配置
    'ruleForm.checkedType': {
      handler: function handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.loadPresetConfigs();
        }
      },
      immediate: true
    },
    // 监听预设配置变化，自动设置默认tab
    allConfigItems: {
      handler: function handler(newVal) {
        if (newVal.length > 0 && !this.activeTab) {
          this.activeTab = 'preset-0';
        } else if (newVal.length === 0) {
          this.activeTab = '';
        }
      },
      immediate: true
    },
    // 今日可导订单发生变更时，更新预计订单数
    todayOrders: function todayOrders(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.updateOrders();
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;
    // 设置默认激活的 tab
    this.$nextTick(function () {
      if (_this2.allConfigItems.length > 0) {
        _this2.activeTab = 'preset-0';
      }
    });
  },
  methods: {
    computeRatio: function computeRatio(list) {
      if (!list || list.length === 0) {
        return 0;
      }
      var total = 0;
      var _iterator = _createForOfIteratorHelper(list),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          total += Number(item.weight);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (total > 100) {
        var message = '总比例已超过100%，请调整！';
        this.$message({
          message: message,
          type: 'warning'
        });
      }
      return total;
    },
    // 加载预设配置
    loadPresetConfigs: function loadPresetConfigs() {
      var _this3 = this;
      this.allConfigItems.splice(0);
      if (this.ruleForm.checkedType) {
        var configItem = this.findConfigTypeItem(this.ruleForm.checkedType);
        if (configItem && configItem.itemList && configItem.itemList.length > 0) {
          var _this$allConfigItems;
          var items = configItem.itemList.map(function (item) {
            return _objectSpread(_objectSpread({}, item), {}, {
              sRatioList: item.sRatioList || [],
              showSContentTab: item.sRatioList && item.sRatioList.length > 0,
              innerActiveTab: 'content'
            });
          });
          (_this$allConfigItems = this.allConfigItems).push.apply(_this$allConfigItems, (0, _toConsumableArray2.default)(items));
        }
      }

      // 如果有预设配置，设置默认激活第一个tab
      this.$nextTick(function () {
        if (_this3.allConfigItems.length > 0) {
          _this3.activeTab = 'preset-0';
        } else {
          _this3.activeTab = '';
        }
      });
    },
    // 配置类型变更处理
    onConfigTypeChange: function onConfigTypeChange() {
      // 清空预设配置列表
      this.allConfigItems.splice(0);
      // 重置激活的tab
      this.activeTab = '';
      // 清空日期选择
      this.date = '';

      // 加载新的预设配置
      this.loadPresetConfigs();
    },
    // 新增预设日期
    addPresetDate: function addPresetDate() {
      if (!this.canAddPresetDate) {
        this.$message({
          message: this.dateValidationMessage || '请检查配置是否正确',
          type: 'warning'
        });
        return;
      }

      // 获取前一天的配置作为默认值
      var _this$getPreviousDayC = this.getPreviousDayConfig(this.date),
        defaultRatioList = _this$getPreviousDayC.ratioList,
        defaultSRatioList = _this$getPreviousDayC.sRatioList;
      var newPresetItem = {
        date: this.date,
        ratioList: defaultRatioList,
        sRatioList: defaultSRatioList,
        showSContentTab: defaultSRatioList.length > 0,
        innerActiveTab: 'content',
        changeState: this.ruleForm.changeState,
        checkedType: this.ruleForm.checkedType,
        saved: false,
        hasUnsavedChanges: defaultRatioList.length > 0
      };
      this.allConfigItems.push(newPresetItem);
      var newTabIndex = this.allConfigItems.length - 1;
      this.activeTab = "preset-".concat(newTabIndex);
      if (defaultRatioList.length > 0) {
        this.updatePresetOrders(newPresetItem);
        this.$message({
          message: "\u5DF2\u6DFB\u52A0 ".concat(this.date, " \u9884\u8BBE\u914D\u7F6E\uFF0C\u5DF2\u81EA\u52A8\u586B\u5145\u524D\u4E00\u5929\u7684\u6A21\u578B\u914D\u7F6E"),
          type: 'success'
        });
      } else {
        this.$message({
          message: "\u5DF2\u6DFB\u52A0 ".concat(this.date, " \u9884\u8BBE\u914D\u7F6E\uFF0C\u8BF7\u6DFB\u52A0\u6A21\u578B\u548C\u6BD4\u4F8B"),
          type: 'success'
        });
      }
      this.date = '';
    },
    // 为预设配置添加模型
    addPresetPattern: function addPresetPattern(presetItem, listKey) {
      var newItem = _objectSpread({}, this.initRatioList[0]);
      presetItem[listKey].push(newItem);
      this.$set(presetItem, 'hasUnsavedChanges', true);
    },
    // 预设配置模型变更处理
    onPresetSelectChange: function onPresetSelectChange(presetItem, ratioIndex, listKey) {
      var ratioItem = presetItem[listKey][ratioIndex];
      var findItem = this.patternList.find(function (item) {
        return item.value === ratioItem.value;
      });
      if (findItem) {
        this.$set(presetItem[listKey][ratioIndex], 'label', findItem.label);
        var limit = findItem.basket && findItem.basket.o_sum ? Number(findItem.basket.o_sum) : 0;
        this.$set(presetItem[listKey][ratioIndex], 'limit', limit);
        this.updatePresetOrders(presetItem);
      }
      this.$set(presetItem, 'hasUnsavedChanges', true);
    },
    // 更新预设配置的预计订单数
    updatePresetOrders: function updatePresetOrders(presetItem) {
      this._updateOrdersForList(presetItem.ratioList);
      if (presetItem.sRatioList) {
        this._updateOrdersForList(presetItem.sRatioList);
      }
    },
    _updateOrdersForList: function _updateOrdersForList(ratioList) {
      for (var i = 0; i < ratioList.length; i++) {
        var ratioItem = ratioList[i];
        if (ratioItem.value !== '') {
          var orders = Math.round(this.todayOrders * (ratioItem.weight / 100));
          if (typeof orders === 'number' && !Number.isNaN(orders)) {
            this.$set(ratioList, i, _objectSpread(_objectSpread({}, ratioItem), {}, {
              orders: orders
            }));
          }
        }
      }
    },
    // 删除预设配置的模型
    deletePresetPattern: function deletePresetPattern(presetItem, ratioIndex, listKey) {
      presetItem[listKey].splice(ratioIndex, 1);
      this.$set(presetItem, 'hasUnsavedChanges', true);
    },
    // 打开预设配置上限设置
    openPresetLimitConfig: function openPresetLimitConfig(presetItem, ratioIndex, listKey) {
      this.$set(presetItem[listKey][ratioIndex], 'showLimit', true);
      this.$set(presetItem, 'hasUnsavedChanges', true);
    },
    // 添加特殊配置值
    onAddSContentForPreset: function onAddSContentForPreset(presetItem) {
      this.$set(presetItem, 'showSContentTab', true);
      this.$set(presetItem, 'sRatioList', [_objectSpread({}, this.initRatioList[0])]);
      this.$set(presetItem, 'innerActiveTab', 's_content');
      this.$set(presetItem, 'hasUnsavedChanges', true);
    },
    // 保存预设配置
    savePresetConfig: function savePresetConfig(presetItem, index) {
      var _this4 = this;
      var ratioList = presetItem.ratioList;
      var sRatioList = presetItem.sRatioList || [];

      // 强导配置值校验
      var validation = this.validatePresetConfig(ratioList);
      if (!validation.valid) {
        this.$message({
          message: validation.message,
          type: 'warning'
        });
        return;
      }

      // 特殊配置值校验（有数据时才校验）
      if (sRatioList.length > 0) {
        var sValidation = this.validatePresetConfig(sRatioList);
        if (!sValidation.valid) {
          this.$message({
            message: '特殊配置值：' + sValidation.message,
            type: 'warning'
          });
          return;
        }
      }
      var content = this.getPresetFormatContent(ratioList);
      var s_content = sRatioList.length > 0 ? this.getPresetFormatContent(sRatioList) : '[]';
      var params = {
        date: presetItem.date,
        class: this.ruleForm.checkedType,
        change_state: this.ruleForm.changeState,
        content: content,
        s_content: s_content
      };

      // 显示加载状态
      var loading = this.$loading({
        lock: true,
        text: '正在保存预设配置...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      // 提交到服务器
      (0, _pattern.submitPresetConfig)(params).then(function (_ref) {
        var code = _ref.code,
          message = _ref.message;
        loading.close();
        if (code === 200) {
          _this4.$message({
            message: "".concat(presetItem.date, " \u9884\u8BBE\u914D\u7F6E\u4FDD\u5B58\u6210\u529F"),
            type: 'success'
          });
          // 标记为已保存，清除未保存修改标记
          _this4.$set(presetItem, 'saved', true);
          _this4.$set(presetItem, 'hasUnsavedChanges', false);
          // 通知父组件刷新数据
          _this4.$emit('refreshPresetConfig');
        } else {
          _this4.$message({
            message: message || '保存失败，请重试',
            type: 'error'
          });
        }
      }).catch(function (error) {
        loading.close();
        _this4.$message({
          message: '保存失败，请检查网络连接后重试',
          type: 'error'
        });
      });
    },
    // 验证预设配置数据
    validatePresetConfig: function validatePresetConfig(ratioList) {
      if (!ratioList || ratioList.length === 0) {
        return {
          valid: false,
          message: '请添加模型比例配置！'
        };
      }

      // 检查总比例
      var totalRatio = this.getPresetTotalRatio(ratioList);
      if (totalRatio !== 100) {
        return {
          valid: false,
          message: '总比例需为100%，请调整！'
        };
      }

      // 检查是否有重复模型
      var seen = new Set();
      var _iterator2 = _createForOfIteratorHelper(ratioList),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var item = _step2.value;
          if (!item.value || item.value === '') {
            return {
              valid: false,
              message: '请选择所有模型！'
            };
          }
          if (seen.has(item.value)) {
            return {
              valid: false,
              message: '存在重复模型配置，请检查并修改！'
            };
          }
          seen.add(item.value);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return {
        valid: true,
        message: '配置验证通过'
      };
    },
    /** 获取格式化content（接口所需） */getPresetFormatContent: function getPresetFormatContent(ratioList) {
      var content = ratioList.map(function (item) {
        var newItem = {
          id: item.value,
          ratios: item.weight,
          o_sum: item.limit,
          expected_fans: item.orders || 0 // 使用 orders 但接口参数名保持 expected_fans
        };
        return newItem;
      });
      return JSON.stringify(content);
    },
    /** 删除预设配置日期 */deletePresetDate: function deletePresetDate(presetItem, index) {
      var _this5 = this;
      this.$confirm('确定要删除此预设配置吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var params = {
          date: presetItem.date,
          class: _this5.ruleForm.checkedType
        };
        (0, _pattern.deletePresetConfig)(params).then(function (_ref2) {
          var code = _ref2.code,
            message = _ref2.message;
          if (code === 200) {
            _this5.$message({
              message: '预设配置删除成功',
              type: 'success'
            });
            _this5.allConfigItems.splice(index, 1);
            _this5.$emit('refreshPresetConfig');
            // 切换到上一个 tab，若已是第一个则切到新的第一个
            _this5.$nextTick(function () {
              if (_this5.allConfigItems.length === 0) {
                _this5.activeTab = '';
              } else {
                var newIndex = index > 0 ? index - 1 : 0;
                _this5.activeTab = "preset-".concat(newIndex);
              }
            });
          } else {
            _this5.$message({
              message: message || '删除失败，请重试',
              type: 'error'
            });
          }
        }).catch(function (error) {
          _this5.$message({
            message: '删除失败，请检查网络连接后重试',
            type: 'error'
          });
        });
      }).catch(function () {
        // 用户取消删除
      });
    },
    // Tab切换处理
    onTabClick: function onTabClick(tab) {
      // 只处理预设配置tab
      if (tab.name.startsWith('preset-')) {
        var presetIndex = parseInt(tab.name.replace('preset-', ''));
        // 直接设置当前编辑的tab
        this.currentEditingTab = presetIndex;
      } else {
        // 切换到非预设配置tab，清除当前编辑状态
        this.currentEditingTab = null;
      }
    },
    // 找到对应的配置类型项
    findConfigTypeItem: function findConfigTypeItem(configType) {
      var configTypeItem = null;
      for (var key in this.presetConfigList) {
        if (key == configType) {
          configTypeItem = this.presetConfigList[key];
          break;
        }
      }
      return configTypeItem;
    },
    /**
     * 更新订单数
     * 时机：
     * 1. 可导订单发生变更；
     * 2. 配置类型发生变更；
     * 3. 模型比例发生变更；
     * 4. 模型发生变更；
     */
    updateOrders: function updateOrders() {
      // 更新所有预设配置的预计订单数
      for (var presetIndex = 0; presetIndex < this.allConfigItems.length; presetIndex++) {
        var presetItem = this.allConfigItems[presetIndex];
        this.updatePresetOrders(presetItem);
      }
    },
    goPatternDetail: function goPatternDetail(id) {
      var findItem = this.patternList.find(function (item) {
        return item.value === id;
      });
      if (findItem) {
        this.$router.push({
          name: 'patternList',
          query: {
            pattern_id: findItem.pattern_product_id
          }
        });
      }
    },
    // 获取预设配置的总上限（只统计比例不为0的模型）
    getPresetTotalLimit: function getPresetTotalLimit(ratioList) {
      if (!ratioList || ratioList.length === 0) {
        return 0;
      }
      var total = 0;
      var _iterator3 = _createForOfIteratorHelper(ratioList),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var item = _step3.value;
          if (Number(item.weight || 0) > 0) {
            total += Number(item.limit || 0);
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return total;
    },
    // 获取预设配置的总比例
    getPresetTotalRatio: function getPresetTotalRatio(ratioList) {
      if (!ratioList || ratioList.length === 0) {
        return 0;
      }
      var total = 0;
      var _iterator4 = _createForOfIteratorHelper(ratioList),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var item = _step4.value;
          total += Number(item.weight);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      return total;
    },
    onDateChange: function onDateChange(date) {
      this.date = date;
    },
    /**
     * 获取前一天的配置数据，用于新增预设日期时默认填充
     * 查找优先级：
     * 1. 当前已添加的预设配置列表（allConfigItems）中前一天的配置
     * 2. 服务端返回的预设配置列表（presetConfigList）中前一天的配置
     * 3. 当前配置类型正在生效的配置（configTypeList）
     */
    getPreviousDayConfig: function getPreviousDayConfig(selectedDate) {
      var prevDate = this.getPreviousDate(selectedDate);
      var checkedType = this.ruleForm.checkedType;

      // 1. 从当前已添加的预设配置列表中查找前一天
      var localItem = this.allConfigItems.find(function (item) {
        return item.date === prevDate;
      });
      if (localItem && localItem.ratioList && localItem.ratioList.length > 0) {
        return {
          ratioList: this.deepCloneRatioList(localItem.ratioList),
          sRatioList: localItem.sRatioList ? this.deepCloneRatioList(localItem.sRatioList) : []
        };
      }

      // 2. 从服务端预设配置列表中查找前一天
      var serverConfig = this.presetConfigList[checkedType];
      if (serverConfig && serverConfig.itemList) {
        var serverItem = serverConfig.itemList.find(function (item) {
          return item.date === prevDate;
        });
        if (serverItem && serverItem.ratioList && serverItem.ratioList.length > 0) {
          return {
            ratioList: this.deepCloneRatioList(serverItem.ratioList),
            sRatioList: serverItem.sRatioList ? this.deepCloneRatioList(serverItem.sRatioList) : []
          };
        }
      }

      // 3. 使用当前配置类型正在生效的配置
      var currentConfig = this.configTypeList.find(function (item) {
        return item.value == checkedType;
      });
      if (currentConfig && currentConfig.ratioList && currentConfig.ratioList.length > 0) {
        return {
          ratioList: this.deepCloneRatioList(currentConfig.ratioList),
          sRatioList: currentConfig.sRatioList ? this.deepCloneRatioList(currentConfig.sRatioList) : []
        };
      }
      return {
        ratioList: [],
        sRatioList: []
      };
    },
    getPreviousDate: function getPreviousDate(dateStr) {
      var date = new Date(dateStr);
      date.setDate(date.getDate() - 1);
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day);
    },
    deepCloneRatioList: function deepCloneRatioList(ratioList) {
      return ratioList.map(function (item) {
        return {
          value: item.value,
          label: item.label,
          weight: item.weight || 0,
          orders: item.orders || 0,
          limit: item.limit || 0,
          showLimit: item.limit > 0
        };
      });
    }
  }
};